import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import favicon from './assets/imgs/favicon.jpg';
import './styles/tailwind.css';
import './index.css';

const faviconLink = document.querySelector<HTMLLinkElement>('#app-favicon');

if (faviconLink) faviconLink.href = favicon;

const container = document.getElementById('root');

if (!container) throw new Error('Root element was not found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
